import * as types from "../../store/mutation-types.js";
import * as globalMutationTypes from "@/store/mutation-types.js";
import icons from "@/mixins/icons.js";
import globalStore from "@/store/index.js";
import bo from "@/mixins/basic-operations.js";
import ValidationService from '@/services/validation.service.js'
import basicgOperations from '@/mixins/basic-operations'
import stringOperations from '@/mixins/string-operations'
import AS from "../../services/agenda-global/agenda.service.js";
import _ from "lodash";
import {
  parseNumber,
  formatNumber,
  AsYouType,
  isValidNumber,
  getNumberType
} from 'libphonenumber-js'

import RSM from "wisaapp-webstudent/src/mixins/right-side-menu.js";
import { getAccountInfo } from "../../store/actions.js";
// import tab from "@/components/utils/tab/tab.vue";
const agendaService = new AS();

const validationService = new ValidationService()
export default {
  name: "Mijn Gegevens",
  mixins: [icons, bo, basicgOperations, stringOperations, RSM],
  // components: {
  //   // tab
  // },
  data: function () {
    return {
      /****************Aanmelden (change passwoord)***** */

      oldPassword: "",
      newPassword: "",
      newPasswordAgain: "",
      confirmPassword: "",
      notification: {
        message: "",
        type: ""
      },
      isProfile: true,
      isChangePassword: false,
      screenRights: this.$store.state.userInfo.screensRightsInformation,
      isModalopen: false,
      /*****************Persoonlijke informatie********** */
      // eslint-disable-next-line no-dupe-keys
      // screenRights:this.$store.state.userInfo.screensRightsInformation,
      cursistInfo: {},
      cursistInfoPersonalia: {},
      cursistInfoPersonaliaExtra: {
        currentPostunmmer: '',
        currentGemeente: '',
        currentDeelgemeente: {
          Postnummer: '',
          DeelGemeente: ''
        }
      },
      editCursistInfoPersonaliaExtra: {
        currentDeelgemeente: {}
      },
      editModal: {
        title: '',
        value: ''
      },
      ibanInfo: [],
      gsmInfo: [],
      telefoonInfo: [],
      filteredListOfGemeentes: [],
      selectedGemeente: {},
      listOfGemeentes: [],
      passwordsInfo: [],
      // participationList:[],
      isAdresChanged: false,
      isGsmChanged: false,
      isTelefoonChanged: false,
      isBankrekeningChanged: false,
      validPhone: true,
    }

  },
  updated() {
    // this.$forceUpdate()
  },
  created: function () {
    this.$store.commit("wstudent/" + types.ZET_CURRENT_SCREEN, "Mijn gegevens");
  },
  beforeCreate: function () {
    // let veranderpaswoord = this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord;
    // // eslint-disable-next-line
    // if (Object.keys(WISA).length === 0 || veranderpaswoord || veranderpaswoord === undefined) {
    //   this.$router.push("/");
    // }
  },
  beforeRouteLeave(to, from, next) {


    if (this.isModalopen) {

      $("#errorMessage").modal("hide");
      this.isModalopen = false

      this.$router.push("/student/mijn-gegevens");
    } else {
      next();
    }
  },
  computed: {
    Adress() {
      return this.editCursistInfoPersonaliaExtra;
    },
    ExtraPersonaliaWatchers() {
      return this.editModal;
    },
    // isAdresChanged(){
    //   if(this.editCursistInfoPersonaliaExtra === this.cursistInfoPersonaliaExtra){

    //     return true
    //   }else{
    //     return false
    //   }

    // },
    /****************Aanmelden (change passwoord)***** */
    huidigversienummer() {
      return this.$store.state.versienummer;
    },
    projectNaam() {
      return this.$store.state.projectNaam;
    },
    serverLocatie() {
      return window.location.hostname;
    },
    accountInfo() {
      return this.$store.state.wstudent.accountInformation;
    },
    gebruikernaam() {
      return this.$store.state.wstudent.accountInformation.gebruikersnaam;
    },
    accountInfoFullname() {
      return this.$store.state.wstudent.accountInformation.fullname;
    },
    laatstelogout() {
      return this.$store.state.wstudent.accountInformation.lastlogin;
    },
    gebruikernummer() {
      return this.$store.state.wstudent.accountInformation.gebruikersnummer;
    },
    personeelID() {
      return this.$store.state.userInfo.loggedInUserInformation.SessionConfig.PersoneelID;
    },

    matchingPassword() {
      if (this.newPassword !== "" && this.newPasswordAgain !== "") {
        return this.newPassword === this.newPasswordAgain;
      } else {
        return false;
      }
    },
    /*****************Persoonlijke informatie********** */
    getcursistInfo() {
      return this.cursistInfo
    },
    editCurusitInfo() {
      return this.cursistInfoPersonalia
    },

    tabs() {
      return [
        {
          name: "student",
          icon: this.icons.DOCUMENT
        },
        {
          name: "configuratieuratie",
          icon: this.icons.PUNTENBOEKJE
        }
      ];
    },
    currentGemeente() {
      return this.editCursistInfoPersonaliaExtra.currentGemeente;
    },
    postnummer() {
      return this.cursistInfoPersonaliaExtra.currentPostunmmer;
    },
    gemeente() {
      return this.cursistInfoPersonaliaExtra.currentGemeente
    }

  },
  watch: {
    ExtraPersonaliaWatchers: {
      handler: function (val, oldval) {
        if (val.value === this.cursistInfoPersonalia.Bankrekening) {
          this.isBankrekeningChanged = true
        } else {
          this.isBankrekeningChanged = false
        }
        if (val.value === this.cursistInfoPersonalia.Gsm) {
          this.isGsmChanged = true
        } else {
          this.isGsmChanged = false
        }
        if (val.value === this.cursistInfoPersonalia.Telefoon) {
          this.isTelefoonChanged = true
        } else {
          this.isTelefoonChanged = false
        }

      },
      deep: true
    },
    Adress: {
      handler: function (val, oldval) {
        if (val.Straat === this.cursistInfoPersonaliaExtra.Straat &&
          val.Straatbus === this.cursistInfoPersonaliaExtra.Straatbus &&
          val.Straatnr === this.cursistInfoPersonaliaExtra.Straatnr &&
          val.currentPostunmmer === this.cursistInfoPersonaliaExtra.currentPostunmmer &&
          val.GemeenteID === this.cursistInfoPersonaliaExtra.GemeenteID
        ) {

          this.isAdresChanged = true
        } else {
          this.isAdresChanged = false

        }
        console.log(val)
        console.log(this.cursistInfoPersonaliaExtra)

      },
      deep: true
    },


    klasType: function (val) {
      this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
        changePartially: true,
        left: "back",
        title: val,
        right: []
      });

    },
    currentGemeente(val) {
      console.log(val)
      if (val.Postnummer !== undefined) {
        this.editCursistInfoPersonaliaExtra.currentPostunmmer = val.Postnummer;
        this.editCursistInfoPersonaliaExtra.currentDeelgemeente = val
      }
    },
    // ibanInfo(val){
    //   this.ibanInfo=val

    // }

  },
  mounted: function () {
    // this.$store.dispatch("wstudent/" +'fetchDemoListGemente', { // for fetching Nationaliteiten (OIMNATIONA)
    //   successCallbackFunction: function (res) {
    //     console.log(res)
    //   }
    //     })
    // this.$store.dispatch("wstudent/" + 'fetchListTest', { // for fetching Nationaliteiten (OIMNATIONA)
    //   successCallbackFunction: function (res) {

    //   }
    // })

    this.allowEditPersonalia()
    /****************Aanmelden (change passwoord)***** */
    let self = this
    $('#errorMessage').on('show.bs.modal', function (e) {
      self.isModalopen = true
    });
    $("#errorMessage").on("hidden.bs.modal", function (e) {
      console.log('gtr')
      self.$router.push('/student/mijn-gegevens')
    });
    if (!this.$store.state.userInfo.screensRightsInformation.myprofile) {
      $("#errorMessage").modal("show")

    }



    globalStore.dispatch("wstudent/" + "getAccountInfo");
    /*****************Persoonlijke informatie********** */
    // eslint-disable-next-line no-dupe-keys


    this.$store.dispatch("wstudent/" + "getLeerling").then(result => {
      this.$store.dispatch("wstudent/" + "getCursistInfo", [result[0].ID]).then(result => {
        console.log(result)
        self.cursistInfo = result[0]
        // self.$store.dispatch("wstudent/" + "getParticipation",  self.cursistInfo.ID).then(result => { 
        //   console.log(result)
        //   self.participationList = result
        // })
      })
      this.$store.dispatch("wstudent/" + "getCursistInfoPersonalia", [result[0].ID]).then(result => {
        console.log(result)
        self.cursistInfoPersonalia = result[0]

      })
      this.$store.dispatch("wstudent/" + "getCursistInfoPersonaliaExtra", [result[0].ID]).then(result => {
        console.log(result)
        this.cursistInfoPersonaliaExtra = result[0]
        this.getGemeenteList(this.cursistInfoPersonaliaExtra)
        // this.cursistInfoPersonaliaExtra.currentDeelgemeente=this.listOfGemeentes.filter(e=>e.ID===this.cursistInfoPersonaliaExtra.GemeenteID)[0]
        // this.cursistInfoPersonaliaExtra.currentPostunmmer= this.cursistInfoPersonaliaExtra.currentDeelgemeente.Postnummer
        // this.cursistInfoPersonaliaExtra.currentGemeente= this.cursistInfoPersonaliaExtra.currentDeelgemeente.DeelGemeente

        // this.cursistInfoPersonalia.currentDeelgemeente=this.listOfGemeentes.filter(e=>e.ID===this.cursistInfoPersonaliaExtra.GemeenteID)[0]

      })
    })


    this.$store.commit(globalMutationTypes.SET_MENUBAR_ITEMS, {
      changePartially: true,
      left: "menu",
      title: 'Mijn gegevens',
      right: []
    });
  },

  methods: {
    isAdresEmpty(value) {
      if (value === '') {
        this.editCursistInfoPersonaliaExtra.Straatnr = ''
        this.editCursistInfoPersonaliaExtra.Straatbus = ''

      }

    },
    allowEditPersonalia() {

      $('#adress').click(function (event) {
        if ($('#adress').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });

      $('#Telefoon1').click(function (event) {
        if ($('#Telefoon1').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });
      $('#Telefoon2').click(function (event) {
        if ($('#Telefoon2').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });

      $('#adress').click(function (event) {
        if ($('#adress').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });

      $('#gsm1').click(function (event) {
        if ($('#gsm1').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });
      $('#gsm2').click(function (event) {
        if ($('#gsm2').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });
      $('#Bankrekening1').click(function (event) {
        if ($('#Bankrekening1').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });
      $('#Bankrekening2').click(function (event) {
        if ($('#Bankrekening2').hasClass('no-modal')) {
          //           e.stopPropagation();
          event.stopPropagation();
        }
      });


    },
    passwordChanged() {
      this.passwordsInfo = this._passwordValidation(this.newPassword, this.newPasswordAgain, true, true)//this.PWMin8 =true, this.PWSpecialChars=true
    },
    postcodeSelected(value) {
      if (value.target.value !== '') {
        // this.filteredListOfGemeentes = []
        let temp = this.listOfGemeentes.filter(function (gemeente) {
          return gemeente.Postnummer.indexOf(value.target.value) !== -1
        })
        this.editCursistInfoPersonaliaExtra.currentGemeente = temp[0]
        this.editCursistInfoPersonaliaExtra.currentDeelgemeente = temp[0]
      }


    },

    getGemeenteList(value) {
      let self = this
      this.$store.dispatch("wstudent/" + "getGemeente").then(result => {
        console.log(result)
        self.listOfGemeentes = _.orderBy(result, ['DeelGemeente'], ['asc']);
        self.cursistInfoPersonaliaExtra.currentDeelgemeente = self.listOfGemeentes.filter(e => e.ID === value.GemeenteID)[0]
        self.cursistInfoPersonaliaExtra.currentPostunmmer = value.currentDeelgemeente.Postnummer
        self.cursistInfoPersonaliaExtra.currentGemeente = value.currentDeelgemeente.DeelGemeente
        self.$forceUpdate();
      })
    },
    /****************Aanmelden (change passwoord)***** */
    hide() {
      // this.$store.commit("wstudent/" + mutationTypes.ZET_GEENLESSEN, false);
      $("#errorMessage").modal("hide");
    },
    showChangePassword() {
      this.isChangePassword = true;
      this.isProfile = false;
    },
    showProfile() {
      this.oldPassword = "";
      this.newPassword = "";
      this.newPasswordAgain = "";
      this.isChangePassword = false;
      this.isProfile = true;
    },
    setChangePassword() {
      let a = [this.oldPassword, this.newPasswordAgain];
      let changePasswordType = ''
      if (this.accountInfo.fullname === 'Systeemgebruiker') {
        changePasswordType = 'changeAdminPassword'
      } else {
        changePasswordType = 'changePassword'
      }
      globalStore.dispatch("wstudent/" + changePasswordType, a).then(result => {
        console.log(result);
        if (result === null) {
          this.showProfile();
          this.$store.commit(globalMutationTypes.SHOW_MESSAGE, ["Uw wachtwoord is gewijzigd"], {
            root: true
          });
        }
      });

      // this.isChangePassword =false
      // this.isProfile=true
    },
    /*****************Persoonlijke informatie********** */
    // eslint-disable-next-line no-dupe-keys
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    save() {

      var editedPayload = new Object;
      var a = this.editModal.title;
      editedPayload[a] = this.editModal.value;

      this.$store.dispatch("wstudent/" + "setLeerlingPersonalia", [this.cursistInfoPersonalia.ID, editedPayload]).then(
        result => {
          $('#EditInfo').modal('hide');
          this.successMessage()
          this.$store.dispatch("wstudent/" + "getLeerling")
          this.$store.dispatch("wstudent/" + "getCursistInfo", [this.cursistInfoPersonalia.ID]).then(result => {
            console.log(result)
            this.cursistInfo = result[0]
          })
          this.$store.dispatch("wstudent/" + "getCursistInfoPersonalia", [this.cursistInfoPersonalia.ID]).then(result => {
            console.log(result)
            this.cursistInfoPersonalia = result[0]
          })
        }).catch(err => {
          // $('#EditInfo').modal('hide');
          this.$swal("Opgelet!", err.response.statusText, "warning");
        })

    },
    successMessage() {
      this.$swal("", "Je wijzigingen zijn bewaard", "success")
    },
    savetype() {
      if (this.editModal.title === "Adres" || this.editModal.title === "Telefoon") {
        this.savePersonaliaExtra()

      } else {
        this.save()
      }
    },
    savePersonaliaExtra() {

      let payload = {}
      let self = this
      if (this.editModal.title === 'Adres') {
        payload = {
          GemeenteID: this.editCursistInfoPersonaliaExtra.currentDeelgemeente.ID,
          Straat: this.editCursistInfoPersonaliaExtra.Straat,
          Straatbus: this.editCursistInfoPersonaliaExtra.Straatbus,
          Straatnr: this.editCursistInfoPersonaliaExtra.Straatnr,
          Telefoon: this.editCursistInfoPersonaliaExtra.Telefoon,
        }
      }
      if (this.editModal.title === 'Telefoon') {
        payload = {
          Telefoon: this.editModal.value

        }
      }
      this.$store.dispatch("wstudent/" + "setLeerlingPersonaliaExtra", [this.cursistInfoPersonaliaExtra.ID, payload]).then(
        result => {
          $('#EditInfo').modal('hide');
          self.successMessage()
          this.$store.dispatch("wstudent/" + "getLeerling")
          this.$store.dispatch("wstudent/" + "getCursistInfo", [this.cursistInfoPersonalia.ID]).then(result => {
            console.log(result)
            this.cursistInfo = result[0]

          })
          this.$store.dispatch("wstudent/" + "getCursistInfoPersonalia", [this.cursistInfoPersonalia.ID]).then(result => {
            console.log(result)
            this.cursistInfoPersonalia = result[0]
          })
          this.$store.dispatch("wstudent/" + "getCursistInfoPersonaliaExtra", [this.cursistInfoPersonalia.ID]).then(result => {
            console.log(result)
            self.cursistInfoPersonaliaExtra = result[0]
            self.cursistInfoPersonaliaExtra.currentDeelgemeente = self.listOfGemeentes.filter(e => e.ID === this.cursistInfoPersonaliaExtra.GemeenteID)[0]
            self.cursistInfoPersonaliaExtra.currentPostunmmer = self.cursistInfoPersonaliaExtra.currentDeelgemeente.Postnummer
            self.cursistInfoPersonaliaExtra.currentGemeente = self.cursistInfoPersonaliaExtra.currentDeelgemeente.DeelGemeente


            self.$forceUpdate();
            // this.cursistInfoPersonalia.currentDeelgemeente=this.listOfGemeentes.filter(e=>e.ID===this.cursistInfoPersonaliaExtra.GemeenteID)[0]

          })

        }).catch(err => {
          // $('#EditInfo').modal('hide');
          this.$swal("Opgelet!", err.response.statusText, "warning");
        })

    },
    inputChanged(a) {
      if (a !== undefined) {

        // if(this.editModal.title==='Telefoon'){

        // }
        this.ibanInfo = validationService.isIban(a.currentTarget.value)//this.PWMin8 =true, this.PWSpecialChars=true
        this.gsmInfo = validationService.isGSM(a.currentTarget.value)
        this.telefoonInfo = validationService.isTelefoon(a.currentTarget.value)
      }

      // if(this.editModal.title==='Bankrekening'){
      //   if(this.editModal.value !==undefined){
      //   this.ibanInfo = C
      //   }
      // }
      // if(this.editModal.title==='Gsm'){
      //   if(this.editModal.value !==undefined){
      //   this.gsmInfo = validationService.isGSM(this.editModal.value)
      //   }
      // }
      // this.ibanInfo = validationService.isIban(this.editModal.value)
      // this.editModal.value = this.cursistInfoPersonalia.Bankrekening
    },
    isNumber(evt) {
      // this.inputChanged(evt)
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 32 && charCode !== 43) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isNumberValid(number, typePhone) {
      if (number == '') {
        return true
      }
      //this.validPhone = false
      let checkIfValid = isValidNumber(number, 'BE')
      this.validPhone = checkIfValid
      console.log(checkIfValid)
      if (number !== '' && checkIfValid) {
        // const numberToFormat = parseNumber(number, 'BE')
        const asYouType = new AsYouType('BE')
        const numberToFormat = parseNumber(number, 'BE')
        let formatedNumber = formatNumber(numberToFormat, 'National')
        console.log(formatedNumber)

        if (numberToFormat.country == 'BE') {
          if (typePhone === 'telefoon') {
            this.editModal.value = formatedNumber
            // this.addressesAndContacts[target].telefoon = formatedNumber
            // this.addressesAndContacts[target].NationalgTelefoon = formatedNumber
            // } else {
            //   let intFormatedNumber = formatNumber({ country: numberToFormat.country, phone: numberToFormat.phone }, 'International')
            //   if ( typePhone === 'telefoon') {
            //     this.editModal.value=intFormatedNumber
            // this.addressesAndContacts[target].telefoon = intFormatedNumber
            // this.addressesAndContacts[target].NationalgTelefoon = intFormatedNumber
          } else {
            // if (number.substring(0, 3) === '+32') {
            this.editModal.value = formatedNumber
            // this.addressesAndContacts[target].gsm = formatedNumber
            // this.addressesAndContacts[target].showGsm = intFormatedNumber

            // } else {
            //   this.editModal.value=intFormatedNumber
            //   // this.addressesAndContacts[target].showGsm = intFormatedNumber
            // }
            // }
          }
        }
        // let national = asYouType ? "BE" && formatNumber(asYouType.national_number, asYouType.country, 'National')
        // console.log(national)
        // return true
      }
    },
    editTypeInfo(a) {
      console.log(a)
      this.editModal.title = a
      this.inputChanged()
      if (a === 'Bankrekening') {
        this.editModal.value = this.cursistInfoPersonalia.Bankrekening
        this.ibanInfo = validationService.isIban(this.editModal.value)
        // this.inputChanged()
      }
      if (a === 'Gsm') {
        this.editModal.value = this.cursistInfoPersonalia.Gsm
        this.gsmInfo = validationService.isGSM(this.editModal.value)
      }
      if (a === 'Telefoon') {
        this.editModal.value = this.cursistInfoPersonaliaExtra.Telefoon
        this.editCursistInfoPersonaliaExtra = JSON.parse(JSON.stringify(this.cursistInfoPersonaliaExtra))
        this.telefoonInfo = validationService.isTelefoon(this.editModal.value)
        // this.ibanInfo = validationService.isGSM(this.editModal.value)
      }
      if (a === 'Adres') {
        this.editCursistInfoPersonaliaExtra = JSON.parse(JSON.stringify(this.cursistInfoPersonaliaExtra))
        // setTimeout(() => {
        //   this.editCursistInfoPersonaliaExtra ={}
        //   this.editCursistInfoPersonaliaExtra= JSON.parse(JSON.stringify(this.cursistInfoPersonaliaExtra))

        // }, 4000);

        this.editModal.value = this.cursistInfoPersonaliaExtra.Adres
        // this.ibanInfo = validationService.isGSM(this.editModal.value)
      }

    },
    closeModal() {
      let self = this;
      // this.modalOpened.onbekendeLeerling=false
      // this.modalOpened.singleStudentPunten=false
      $("#EditInfo").on("hidden.bs.modal", function () {
        $("#EditInfo").modal("hide");
      });

    },

  }
};
